import cn from "classnames"

import { Text, Title } from "@/atoms"
import { Trans } from "@/hooks/useTranslation"
import { InformationCard } from "@/molecules/InformationCard"

import styles from "./PrerequisitesSection.module.scss"

import type { PrerequisitesSectionProps } from "./PrerequisitesSection.types"

export const PrerequisitesSection = ({
  section,
  classes = {}
}: PrerequisitesSectionProps) => (
  <div>
    <Title level={5} className={cn(styles.title, classes.title)}>
      {section.title}
    </Title>
    <InformationCard infoMessage={section.noteTitle || "Prerequisites"}>
      {section.description && (
        <span className={styles.description}>{section.description}</span>
      )}
      <ul className={styles.listPrerequisites}>
        {section.prerequisites?.map((item: any, index: number) => {
          if (typeof item === "string") {
            return (
              <li key={index}>
                <Text>
                  <Trans>{item}</Trans>
                </Text>
              </li>
            )
          }

          return Object.keys(item).map((key: string) => (
            <li key={key}>
              <Text>{key}</Text>
              <ul>
                {item[key].map((subItem: string) => (
                  <li key={subItem}>
                    <Text>{subItem}</Text>
                  </li>
                ))}
              </ul>
            </li>
          ))
        })}
      </ul>
    </InformationCard>
  </div>
)
